import { ReactElement } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export interface TextInputProps {
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  errors?: any;
  register?: any;
  suffix?: ReactElement;
}

export default function TextInput({
  type = 'text',
  name,
  label,
  placeholder,
  disabled,
  errors,
  register = () => ({}),
  suffix
}: TextInputProps) {
  return (
    <div className="relative">
      {label && <Label htmlFor={name}>{label}</Label>}
      <Input
        placeholder={placeholder}
        type={type}
        autoCapitalize="none"
        autoComplete="off"
        autoCorrect="off"
        disabled={disabled}
        {...register(name)}
      />
      {suffix}
      {errors && errors[name] && (
        <p className="px-1 text-xs text-red-600">{errors[name].message}</p>
      )}
    </div>
  );
}
